<template>
  <div>
    <div>
      <b-container class="px-0 bg-white-border">
        <div class="p-3">
          <div class="header-container">
            <div class="mr-2">
              <b-button-group class="buttongroup-custom w-100">
                <b-button
                  :class="[
                    tabIndex === 1 ? 'button-active' : 'button-unactive',
                  ]"
                  @click="onClickTab(1)"
                  >Day</b-button
                >
                <b-button
                  :class="[
                    tabIndex === 2 ? 'button-active' : 'button-unactive',
                  ]"
                  @click="onClickTab(2)"
                  >Week</b-button
                >
                <b-button
                  :class="[
                    tabIndex === 3 ? 'button-active' : 'button-unactive',
                  ]"
                  @click="onClickTab(3)"
                  >Month</b-button
                >
              </b-button-group>
            </div>
            <div
              class="d-flex align-items-center justify-content-between mb-2 my-md-0"
            >
              <span class="f-size-12">DATE: FORM </span>
              <div class="date-container">
                <datetime
                  class="date-picker"
                  value-zone="Asia/Bangkok"
                  placeholder="yyyy-mm-dd"
                  v-model="filter.startDate"
                  @close="onSelectDate"
                ></datetime>
              </div>
              <span class="f-size-12"> TO </span>
              <div class="date-container mr-0">
                <datetime
                  class="date-picker"
                  value-zone="Asia/Bangkok"
                  placeholder="yyyy-mm-dd"
                  v-model="filter.endDate"
                  @close="onSelectDate"
                ></datetime>
              </div>
              <b-dropdown
                id="dropdown-filter"
                variant="outline"
                right
                ref="dropdownfilter"
                class="filter-custom"
                no-flip
              >
                <template v-slot:button-content>
                  <font-awesome-icon icon="filter" class="mr-2" />FILTER
                </template>
                <div>
                  <p class="mb-2 dropdown-date-custom-text">Channel</p>
                </div>
                <b-dropdown-divider></b-dropdown-divider>
                <div>
                  <div class="input-flex-container">
                    <div
                      class="w-100 text-center my-2"
                      v-if="isLoadingPlatformConfigList"
                    >
                      <b-spinner small></b-spinner>
                    </div>
                    <div v-else>
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox
                          v-for="(option, index) in platformConfigList"
                          v-model="filter.platformConfigId"
                          :key="`platformConfigId-${option.platformConfigId}-${index}`"
                          :value="option.platformConfigId"
                          :aria-describedby="ariaDescribedby"
                        >
                          <img
                            width="15"
                            height="15"
                            :src="option.imageUrl"
                            alt=""
                          />
                          {{ option.name }}
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>

                  <template v-if="conversationTopics.length">
                    <div>
                      <p class="mb-2 dropdown-date-custom-text">Topic</p>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <div>
                      <div class="input-flex-container mb-2">
                        <div class="w-100">
                          <!-- <b-form-checkbox-group
                            v-model="filter.topicId"
                            :options="conversationTopics"
                            class="mb-3"
                            value-field="id"
                            text-field="name"
                          ></b-form-checkbox-group> -->
                          <multiselect
                            id="topics-dropdown"
                            v-model="filter.topicArr"
                            :options="conversationTopicsFilter"
                            :multiple="true"
                            :group-select="false"
                            :close-on-select="false"
                            placeholder="Select Topic"
                            track-by="id"
                            label="name"
                            :option-disabled="(option) => option.isGroup"
                          >
                            <!-- @input="onSelectOption" -->
                            <template v-slot:noResult>ไม่พบข้อมูล</template>
                            <template #option="{ option }">
                              <div
                                v-if="option.isGroup"
                                class="group-header"
                                @mousedown.prevent
                                @click.prevent.stop="
                                  toggleGroup(option.groupName)
                                "
                              >
                                <div class="group-name">
                                  {{ option.groupName }}
                                </div>
                                <div class="group-icon">
                                  {{
                                    topicsGroups.includes(option.groupName)
                                      ? "▼"
                                      : "►"
                                  }}
                                </div>
                              </div>
                              <div
                                :class="
                                  !option.isGroup &&
                                  option.groupName &&
                                  !topicsGroups.includes(option.groupName)
                                    ? 'group-item'
                                    : 'item'
                                "
                              >
                                {{ option.name }}
                              </div>
                            </template>
                          </multiselect>
                          <div
                            class="d-flex justify-content-between multiselect__bottom"
                          >
                            <span class="count-selected"
                              >Selected : {{ filter.topicArr.length }}</span
                            >
                            <span class="clear" @click="filter.topicArr = []"
                              >Clear</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div>
                    <p class="mb-2 dropdown-date-custom-text">Search</p>
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <div class="mt-2">
                    <multiselect
                      :close-on-select="false"
                      :clear-on-select="false"
                      multiple
                      v-model="filter.teamRoleMappingIdArr"
                      :options="teams"
                      placeholder="Select Team"
                      track-by="roleMappingId"
                      label="name"
                    ></multiselect>
                    <div
                      class="d-flex justify-content-between multiselect__bottom"
                    >
                      <span class="count-selected"
                        >Selected :
                        {{ filter.teamRoleMappingIdArr.length }}</span
                      >
                      <span
                        class="clear"
                        @click="filter.teamRoleMappingIdArr = []"
                        >Clear</span
                      >
                    </div>
                  </div>
                  <b-dropdown-divider></b-dropdown-divider>
                  <div class="mt-2">
                    <multiselect
                      :close-on-select="false"
                      :clear-on-select="false"
                      multiple
                      v-model="filter.agentGuidArr"
                      :options="agents"
                      placeholder="Select Agent"
                      track-by="userGUID"
                      label="agentName"
                    ></multiselect>
                    <div
                      class="d-flex justify-content-between multiselect__bottom"
                    >
                      <span class="count-selected"
                        >Selected : {{ filter.agentGuidArr.length }}</span
                      >
                      <span class="clear" @click="filter.agentGuidArr = []"
                        >Clear</span
                      >
                    </div>
                  </div>
                  <div class="mt-3">
                    <b-button class="w-100 submit-button" @click="getAllData">
                      <div>
                        <span> Search </span>
                      </div>
                    </b-button>
                  </div>
                </div>
              </b-dropdown>
            </div>
          </div>

          <div class="my-4">
            <b-row class="no-gutters">
              <b-col cols="12" sm="3">
                <div class="m-0 mb-4 mb-sm-0 mr-sm-1 stat-container">
                  <p>Total Chat Created</p>
                  <span class="number">{{
                    widgetData.totalCreatedChat | numeral("0,0")
                  }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="3">
                <div class="m-0 mb-4 mb-sm-0 mx-sm-1 stat-container">
                  <p>Total Chat Closed</p>
                  <span class="number">{{
                    widgetData.totalClosedChat | numeral("0,0")
                  }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="3">
                <div class="mr-0 mb-4 mb-sm-0 mx-sm-1 stat-container">
                  <p>Avg. Resolution Time</p>
                  <span class="number">{{
                    secsToTime(widgetData.avgResolution)
                  }}</span>
                </div>
              </b-col>
              <b-col cols="12" sm="3">
                <div class="m-0 mb-4 mb-sm-0 ml-sm-1 stat-container">
                  <p>Avg. Wait Time</p>
                  <span class="number">{{
                    secsToTime(widgetData.avgWaitTime)
                  }}</span>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- <b-row class="no-gutters my-3">
            <b-col cols="12" class="mb-3 mb-xl-0 text-right">
              <button class="create-button ml-2" @click="onSwitchView">
                Switch View
              </button>
            </b-col>
          </b-row> -->
          <div class="mt-3">
            <b-row class="no-gutters my-3">
              <b-col cols="12" class="mb-3 mb-xl-0 row-container">
                <div class="mr-xl-2 bg-white p-3">
                  <div class="d-flex justify-content-between">
                    <div
                      class="d-flex align-items-center justify-content-start"
                    >
                      <strong>Productivity Report for Rostering</strong>
                      <b-form-checkbox
                        class="mx-2"
                        v-model="filter.isClosedChatOnly"
                        @input="getAllData"
                      >
                        {{ $t("closedChatOnly") }}
                      </b-form-checkbox>
                    </div>
                    <b-button @click="exportExcel(1)" variant="export">
                      <div>
                        <span>Export</span>
                      </div>
                    </b-button>
                  </div>
                  <div v-if="isProductivity">
                    <div class="text-center">
                      <img
                        src="@/assets/images/icons/loading.svg"
                        alt="loading"
                        class="mb-3 img"
                        width="50px"
                        height="50px"
                      />
                    </div>
                  </div>
                  <div
                    v-else
                    class="mt-3 chart-h-heatmap"
                    :style="{
                      height: dataProductivity.rowsY * 40 + 100 + 'px',
                    }"
                  >
                    <JSCharting
                      :options="chartProductivityOptions"
                      v-if="!isProductivity"
                      ref="chart01"
                    ></JSCharting>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-container>
    </div>
    <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";
import moment from "moment";
import Multiselect from "vue-multiselect";
import JSCharting from "jscharting-vue";

export default {
  components: {
    ModalLoading,
    Multiselect,
    JSCharting,
  },
  name: "Chart",
  data: function () {
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setUTCHours(0, 0, 0, 0);
    const endDate = new Date();
    endDate.setUTCHours(0, 0, 0, 0);
    return {
      isProductivity: true,
      dataProductivity: {
        rowsX: 0,
        rowsY: 0,
      },
      startDate: "",
      yAxisTitle: "Week",
      endDate: "",
      tabIndex: 2,
      filter: {
        startDate: "",
        endDate: "",
        ViewAs: 2,
        channelId: [],
        topicId: [],
        topicArr: [],
        agentGuid: [],
        agentGuidArr: [],
        teamRoleMappingIds: [],
        teamRoleMappingIdArr: [],
        platformConfigId: [],
        isClosedChatOnly: false,
      },
      widgetData: {
        avgResolution: 0,
        avgWaitTime: 0,
      },
      channelList: [],
      isLoadingChannelList: false,
      platformConfigList: [],
      isLoadingPlatformConfigList: false,
      conversationTopics: [],
      topicsGroups: [],
      pageOptions: [
        { value: 10, text: `10 / Page` },
        { value: 30, text: `30 / Page` },
        { value: 50, text: `50 / Page` },
        { value: 100, text: `100 / Page` },
      ],
      isBusy: false,
      rows: 0,
      startPage: 1,
      endPage: 10,
      msgModal: null,
      modalMessage: "",
      sortBy: "agentName",
      sortDesc: false,
      agents: [],
      isLoadingAgent: false,
      teams: [],
      isLoadingTeam: false,
      switchViewId: 1,
      chartProductivityOptions: {
        debug: true,
        id: "productivity-chart",
        type: "heatmap",
        toolbar_visible: false,
        legend: {
          position: "middle right",
        },
        palette: {
          pointValue: "{%zValue}",
          stops: [
            [0, "#ffffff"],
            [30, "#68cbbb"],
          ],
          colorsValueRange: [0, 30],
        },
        defaultPoint: {
          tooltip: "<b>%yValue</b> (%xValue)<br/>Total Chat: %zValue",
          label_text: "%zValue",
          outline_width: 0,
          outline_color: "none",
        },
        zAxis_label_text: "",
        xAxis: {
          label_text: "Admin",
          autoRotate: -45,
        },
        yAxis: {
          label_text: "Time",
        },
        series: [
          {
            name: "productivity-chart",
            points: [],
          },
        ],
      },
    };
  },
  methods: {
    getProductivity: async function () {
      this.isProductivity = true;
      const url = `${this.$baseUrl}/analytics/GetAgentPerformanceReport/HeatMap`;
      await this.axios
        .post(url, this.filter)
        .then(async (data) => {
          if (data.result === 1) {
            await this.convertDataHeatmap(data.detail, "Productivity");
            this.isProductivity = false;
          }
        })
        .catch((error) => {
          this.isProductivity = false;
        });
    },
    async convertDataHeatmap(res, key) {
      let max = res.max || 1;
      this[`data${key}`].rowsY = res.times.length || 0;
      this[`data${key}`].rowsX = res.chatDates.length || 0;
      this[`chart${key}Options`].palette.colorsValueRange = [0, max];
      let points = [];
      var totalPerTime = [];
      var totalPerAdmin = [];

      for (const data of res.data) {
        points.unshift({
          y: data.time,
          x: data.chatDate,
          z: data.count,
        });
      }

      for (const day of res.chatDates) {
        totalPerAdmin.push({
          y: `Total Time`,
          x: day,
          z: res.totalPerChatDate[day],
          color: "#797979",
        });
      }

      totalPerTime.push({
        y: `Total Time`,
        x: `Total Days`,
        z: res.grandTotal,
        color: "#555555",
      });

      for (const time of res.times) {
        let total = res.totalPerTime[time] || 0;
        totalPerTime.push({
          x: `Total Days`,
          y: time,
          z: total,
          color: "#797979",
        });
      }

      points = [...totalPerAdmin, ...totalPerTime, ...points];

      this[`chart${key}Options`].palette.stops = [
        [0, "#ffffff"],
        [max, "#68cbbb"],
      ];
      this[`chart${key}Options`].series[0].points = points;
    },
    onSelectDate() {
      if (this.filter.startDate && this.filter.endDate) {
        this.getAllData();
      }
    },
    onClickTab: async function (idx) {
      this.tabIndex = idx;
      this.filter.ViewAs = idx;
      if (idx == 1) {
        this.yAxisTitle = "Day";
        // this.filter.startDate = moment().subtract(1, "day").format();
      } else if (idx == 2) {
        this.yAxisTitle = "Week";
        // this.filter.startDate = moment().subtract(1, "week").format();
      } else if (idx == 3) {
        this.yAxisTitle = "Month";
        // this.filter.startDate = moment().subtract(1, "month").format();
      } else {
        this.yAxisTitle = "Week";
        // this.filter.startDate = moment().subtract(1, "week").format();
      }

      // this.filter.endDate = moment().format();
      await this.getAllData();
    },
    getWidget: async function () {
      const url = `${this.$baseUrl}/analytics/Widget`;
      await this.axios.post(url, this.filter).then((data) => {
        if (data.result === 1) {
          this.widgetData = data.detail;
        }
      });
    },
    getAllPlatformConfig: async function () {
      const url = `${this.$baseUrl}/analytics/get-all-platform-config`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          this.platformConfigList = data.detail;
        }
      });
    },
    getChannel: async function () {
      const url = `${this.$baseUrl}/analytics/Filter/Channel`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          this.channelList = data.detail;
        }
      });
    },
    getConversationTopics: async function () {
      await this.axios(`${this.$baseUrl}/FlowBuilder/Topics`)
        .then((data) => {
          if (data.result === 1) {
            this.conversationTopics = data.detail;
          }
        })
        .catch((error) => {
          this.conversationTopics = [];
        });
    },
    getAllData: async function () {
      this.filter.startDate = moment(this.filter.startDate).format(
        "YYYY-MM-DDT00:00:00+07:00"
      );
      this.filter.endDate = moment(this.filter.endDate).format(
        "YYYY-MM-DDT23:59:59+07:00"
      );

      this.filter.topicId = await this.filter.topicArr.map((e) => e.id);

      this.filter.agentGuid = await this.filter.agentGuidArr.map(
        (e) => e.userGUID
      );
      this.filter.teamRoleMappingIds =
        await this.filter.teamRoleMappingIdArr.map((e) => e.roleMappingId);

      await this.getWidget();
      await this.getProductivity();
    },
    async exportExcel(typeNumber) {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";

      const body = {
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        ViewAs: this.filter.ViewAs,
        channelId: this.filter.channelId,
        topicId: this.filter.topicId,
        agentGuid: this.filter.agentGuid,
        teamRoleMappingIds: this.filter.teamRoleMappingIds,
        platformConfigId: this.filter.platformConfigId,
        isClosedChatOnly: this.filter.isClosedChatOnly,
      };
      body.topicId = await this.filter.topicArr.map((e) => e.id);
      body.agentGuid = await this.filter.agentGuidArr.map((e) => e.userGUID);
      body.teamRoleMappingIds = await this.filter.teamRoleMappingIdArr.map(
        (e) => e.roleMappingId
      );

      let path = "";
      let fileName = "";

      if (typeNumber == 1) {
        path = "analytics/GetAgentPerformanceReport/HeatMap/export";
        fileName = "Productivity_Report_for_Rostering";
      }
      try {
        await this.axios
          .post(`${this.$baseUrl}/${path}`, body, {
            responseType: "blob",
          })
          .then(async (response) => {
            this.$refs.modalLoading.hide();
            const isJsonBlob = (data) =>
              data instanceof Blob && data.type === "application/json";
            const responseData = isJsonBlob(response)
              ? await response?.text()
              : response || {};
            if (typeof responseData === "string") {
              const responseJson = JSON.parse(responseData);
              this.$refs.modalLoading.hide();
              this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
                isShow: true,
                msg: responseJson.message,
              });
            } else {
              var fileURL = window.URL.createObjectURL(new Blob([response]));
              var fileLink = document.createElement("a");
              var startDate = moment(this.filter.startDate).format("YYYYMMDD");
              var endDate = moment(this.filter.endDate).format("YYYYMMDD");

              fileLink.href = fileURL;
              fileLink.setAttribute(
                "download",
                `${fileName}_${startDate}-${endDate}.xlsx`
              );
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$refs.modalLoading.hide();
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: error.message,
            });
          });
      } catch (err) {
        console.error(err);
        this.$refs.modalLoading.hide();
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: error.message,
        });
      }
    },
    secsToTime(secs) {
      let d = (secs / 8.64e4) | 0;
      let H = ((secs % 8.64e4) / 3.6e3) | 0;
      let m = ((secs % 3.6e3) / 60) | 0;
      let s = secs % 60;
      // let z = (n) => (n < 10 ? "0" : "") + n;
      let result = "";
      if (d) result += `${d}d `;
      if (H) result += `${H}h `;
      if (m) result += `${m}m `;
      result += `${Math.round(s)}s`;
      return result;
    },
    getAgents: async function () {
      this.isLoadingAgent = true;
      await this.axios(`${this.$baseUrl}/customer/list/Agent`)
        .then((data) => {
          if (data.result === 1) {
            this.agents = data.detail;
            this.isLoadingAgent = false;
          }
        })
        .catch((error) => {
          this.agents = [];
          this.isLoadingAgent = false;
        });
    },
    getTeams: async function () {
      this.isLoadingTeam = true;
      let body = {
        pageNo: 1,
        perPage: 999,
        search: "",
      };
      await this.axios
        .post(`${this.$baseUrl}/Team/list/name`, body)
        .then((data) => {
          if (data.result === 1) {
            this.teams = data.detail.data;
            this.isLoadingTeam = false;
          }
        })
        .catch((error) => {
          this.teams = [];
          this.isLoadingTeam = false;
        });
    },
    onSwitchView() {
      this.switchViewId = this.switchViewId == 1 ? 2 : 1;
    },
    toggleGroup(groupName) {
      const index = this.topicsGroups.indexOf(groupName);
      if (index > -1) {
        this.topicsGroups.splice(index, 1);
      } else {
        this.topicsGroups.push(groupName);
      }
      this.filter.topicArr = this.filter.topicArr.filter(
        (item) => !item.isGroup
      );
    },
    onSelectOption(option) {
      const filtered = option.filter((item) => !item.isGroup);
      this.filter.topicArr = filtered;
    },
  },
  mounted: async function () {
    // var duration = moment.duration(moment().diff("2024-12-23"));
    // if(duration.asMonths() < 6) {
    // this.filter.startDate = moment("2024-12-23T00:00:00").format();
    // }else{
    //   this.filter.startDate = moment().subtract(6, "months").format();
    // }
    this.filter.startDate = moment().subtract(1, "months").format();

    this.filter.endDate = moment().format();
    this.getAllPlatformConfig();
    this.getConversationTopics();
    this.getAgents();
    this.getTeams();
    await this.getAllData();
  },
  computed: {
    conversationTopicsFilter() {
      return this.conversationTopics.flatMap((group) => {
        const hasGroup = group.groupName;

        const headerGroup = hasGroup
          ? [{ isGroup: true, groupName: group.groupName }]
          : [];

        const items = group.topics.map((item) => ({
          ...item,
          groupName: group.groupName || null,
        }));

        return [...headerGroup, ...items];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-12 {
  font-size: 12px;
}

.date-container {
  max-width: 35%;
  margin: 0 0.5rem;
}

.row-container {
  border: 1px solid #dedede;
}

.stat-container {
  padding: 1rem;
  // border-radius: 4px;
  background: #e2dff3;
  color: #3c4b64;
  height: 100%;
  border-left: 5px solid #7160c4;
  .number {
    font-size: 1.75rem;
    font-weight: bold;
  }
}

.header-container {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
::v-deep .input-flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .custom-control-inline {
    width: 43% !important;
  }
}
::v-deep .dropdown-menu-right {
  min-width: 450px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}
.submit-button {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
}
#dropdown-filter {
  position: absolute;
  right: 0;
  top: 0;
}
.btn-export {
  padding: 0;
  text-decoration: underline;
}
.chart-h-heatmap > div {
  height: 100%;
}

::v-deep .multiselect__option {
  :has(.group-header) {
    padding: 0 !important;
  }
}
::v-deep .multiselect__element {
  :has(.group-header) {
    color: #35495e;
    background-color: #f0f0f0;
    padding: 0 !important;
    &:hover {
      background-color: #b41bb4;
      color: #ffffff;
    }

    &::after {
      display: none;
    }
  }

  :has(.group-item) {
    display: none !important;
  }

  span {
    padding-left: 10px;
  }
}

::v-deep .multiselect__tag {
  max-width: 300px;
}

::v-deep .multiselect__element {
  span {
    max-width: 390px;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.group-header {
  padding: 12px 12px 15px 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #f0f0f0;

  .group-icon {
    font-size: 10px;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
  }
}

.group-header:hover {
  background-color: #b41bb4;
}

.group-item,
.item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding-left: 10px;
}

@media (max-width: 720px) {
  .header-container {
    flex-direction: column-reverse;
  }
}
</style>
